import type {
  EventMarketPeriodTypes,
  EventRunnerType,
} from "app/types/eventType";
import { MarketTypes } from "app/utils/const";

export class HomeAwaySidesHelper {
  static checkDisplayEmptyRunner = (
    runner: EventRunnerType,
    marketType: EventMarketPeriodTypes
  ) => {
    const hasPrices =
      runner.hasOwnProperty("aggregatedPrices") &&
      Array.isArray(runner.aggregatedPrices) &&
      runner.aggregatedPrices.length > 0;

    if (!hasPrices) {
      if (marketType && marketType.marketType === MarketTypes.OUTRIGHT) {
        return false;
      }

      return true;
    }
  };
}
